import { useFalconStore } from "../stores/falcon.store";

export const useTranslatedProperty = <T>(obj: T, propName: keyof T) => {
    const lng = useFalconStore().config.lng;
    if (lng === "en") {
        return obj?.[propName];
    }
    return obj?.[`${propName as string}_Translations`]?.[lng];
};
